/**
 * CRM-действия меню «Создать ▾» в шапке Activity-чата.
 *
 * Доступность по типу треда:
 * - «Новая задача» — партнёр / лид;
 * - «Новая сделка» — только партнёр (резолвит партнёра и после создания
 *   открывает Drawer созданной сделки).
 */
import logger from '@ayocore/platform/common/helpers/logger';
import {
  ACTIVITY_TASK_THREAD_ENTITY_TYPE,
  CRM_ACTIVITY_ENTITY_TYPES,
} from '@ayocore/activity/common/activity/constants';
import type { ActivityHeaderAction } from '@ayocore/activity/client/extensions';
import { partnerRepository } from '@ayocore/erp/crm/client/rpc';
import { CrmCreateTaskForm, isTaskEntityType } from '../components/tasks/CrmCreateTaskForm';
import { CreateDealForm } from '../components/Deals/forms/CreateDealForm';
import { DealView } from '../components/Deals/views/DealView';

export const crmNewTaskHeaderAction: ActivityHeaderAction = {
  id: 'crm_new_task',
  // По требованию: задача доступна из активити для треда партнёра, лида
  // и проекта (подзадача). Для треда сделки/контакта — пункт скрыт.
  label: 'Новая задача',
  isAvailable: entityType =>
    entityType === CRM_ACTIVITY_ENTITY_TYPES.PARTNER ||
    entityType === CRM_ACTIVITY_ENTITY_TYPES.LEAD ||
    entityType === ACTIVITY_TASK_THREAD_ENTITY_TYPE,
  onSelect: ({ entityType, entityUuid }, helpers) => {
    if (!isTaskEntityType(entityType)) return;
    const modal = helpers.openModal(
      <CrmCreateTaskForm
        entityUuid={entityUuid}
        entityType={entityType}
        onCreated={() => modal.close()}
      />,
      { title: 'Новая задача', inputSize: 'sm' }
    );
  },
};

export const crmNewDealHeaderAction: ActivityHeaderAction = {
  id: 'crm_new_deal',
  label: 'Новая сделка',
  isAvailable: entityType => entityType === CRM_ACTIVITY_ENTITY_TYPES.PARTNER,
  onSelect: async ({ entityUuid }, helpers) => {
    try {
      const partner = await partnerRepository.findById(entityUuid);
      if (!partner) {
        logger.warn('[crm-activity-header-actions] partner not found', { entityUuid });
        return;
      }
      const modal = helpers.openModal(
        <CreateDealForm
          initialData={{ partner_id: partner.id }}
          initialSelectOptions={{
            partner_id: { value: String(partner.id), label: partner.name ?? '' },
          }}
          onDealCreated={deal => {
            modal.close();
            if (deal?.id) {
              helpers.openDrawer(<DealView dealId={deal.id} isModal />);
            }
          }}
        />,
        { title: 'Создать новую сделку' }
      );
    } catch (error) {
      logger.error('[crm-activity-header-actions] open create deal failed', { error });
    }
  },
};
